import axios from 'axios'
import { getAPIUrl } from '../API'
import { v4 as uuid } from 'uuid'

export interface SearchPropertyByOwnerRequest {
  idNo: string | null
  region: string
  suburb: string
  surname: string
  municipalityCode: string
}

export interface FullTitle {
  uuid: string
  cmaid: number
  erfNo: string
  streetNo: string
  address: string
  suburb: string
  owner: string
  ownerIDNo: string
}

export interface SectionalTitle {
  uuid: string
  schemeNo: number
  sectionNo: number
  flatNo: string
  schemeName: string
  address: string
  suburb: string
  owner: string
  ownerIDNo: string
}

export interface PropertySearchByOwnerResponse {
  fullTitles: FullTitle[]
  sectionalTitles: SectionalTitle[]
  fullTitleCount: number
  sectionalTitleCount: number
}

export const searchPropertyByOwner: (
  options: SearchPropertyByOwnerRequest,
) => Promise<PropertySearchByOwnerResponse> = async (options) => {
  const { data } = await axios.post(
    `${getAPIUrl()}/BridgingFinance/searchpropertybyowner`,
    options,
    {
      headers: {
        Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
      },
    },
  )
  if (data.data.fullTitleCount === 0 && data.data.sectionalTitleCount === 0) {
    if (options.idNo) {
      alert(`No results found for Id number: ${options.idNo}`)
    } else if (options.surname) {
      alert(`No results found for surname: ${options.surname}`)
    }
  }
  const result: PropertySearchByOwnerResponse = {
    ...data.data,
    fullTitles: data.data.fullTitles.map((item: FullTitle) => ({
      ...item,
      uuid: uuid(),
    })),
    sectionalTitles: data.data.sectionalTitles.map((item: SectionalTitle) => ({
      ...item,
      uuid: uuid(),
    })),
  }
  return result
}
